/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Team_Share_Created_OnInputs */



/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Team_Share_Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_created_on = /** @type {((inputs: Team_Share_Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Created ${i?.date}`)
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
});